<template>
  <li class="sticky-counter-item" :class="{ active: isActive }">
      <h2 class="sticky-counter-item__title">{{ content.title }}</h2>
      <p class="sticky-counter-item__text">{{ content.text }}</p>
  </li>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "StickyCounterItem",
  components: {},
  props: {
      content: Object,
      index: Number,
      isActive: Boolean,
      activatePercentsFromTop: Number
  },
  data() {
    return {
      iAmActiveAt: {
        top: 0,
        bottom: 0
      }
    };
  },
  computed: {
    ...mapState({
      currentScroll: state => state.globals.currentScroll,
      screenHeight: state => state.globals.screenHeight,
    }),
    offsetPercentInPixels() {
      return (this.screenHeight * (this.activatePercentsFromTop / 100))
    }
  },
  watch: {
    currentScroll(scroll) {
      if(scroll > this.iAmActiveAt.top && scroll < this.iAmActiveAt.bottom) {
        this.iAmActive()
      }
      
      this.calcOffsetFromTop() // a bit non-performant
    }
  },
  methods: {
    iAmActive() {
      this.$emit('newActive', this.index)
    },
    calcOffsetFromTop() {
      this.iAmActiveAt = {
        top: this.$el.getBoundingClientRect().top + this.currentScroll - this.offsetPercentInPixels,
        bottom: this.$el.getBoundingClientRect().bottom + this.currentScroll - this.offsetPercentInPixels,
      }
    }
  },
  mounted() {
    this.calcOffsetFromTop()
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.sticky-counter-item {
  @extend %title-margin-3;

  &:last-of-type {
    margin-bottom: 0;
  }
  
  transition: color .3s;

  list-style: none;
  color: lighten(black, 90%);

  &.active {
    color: $color-black;
  }

  &__title {
    @include typeset(display-2);
    @extend %title-margin-2;

    @media screen and (min-width: 769px) {
      @include typeset(display-1);
    }
  }
  &__text {
    @include typeset(body-normal);

    max-width: 35em;

    @media screen and (min-width: 769px) {
      @include typeset(body-large);
    }
  }
}
</style>
